import { render } from "./BerkasView.vue?vue&type=template&id=f15f0fe2"
import script from "./BerkasView.vue?vue&type=script&lang=js"
export * from "./BerkasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__